import React, { useRef, useState } from 'react';
import { Card, Wizard, NotificationList } from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileAlt,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import RenewReviewAndConfirm from './renew-review-confirm';
// import SuccessPageHealth from '../../../../common/SuccessPageHealth/health';
import {SuccessPageHealth} from'quanta-flows/modules/common/success';

// import Loading from '../../../../../lib/layout/loading';
import { Loading,Error } from 'quanta-flows/modules/layout';
// import { updateViewRenewPolicy } from '../_graphql/state';
import { updateViewRenewPolicy } from 'quanta-flows/modules/policy/renewal/health/state'; 
// import PayPremium from '../../../../common/pay-premium/pay-premium-health';
 import {PayPremium} from 'quanta-flows/modules/common/payPremium';
// import PayPremium from'quanta-flows/src/modules/common/pay-premium/pay-premium-health';
// import { GET_VIEW_RENEW_POLICY_VAR_DETAILS } from 'quanta-flows/modules/policy/renewal/health';
import { GET_VIEW_RENEW_POLICY_VAR_DETAILS } from '../queries';


export default function RenewViewPolicyWizardPanel({
  planName,
  planCode,
  productCode,
  productName,
  rcStatus,
  renewalMode,
  ...props
}) {
  const [successMsg, showSuccessMsg] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [loadingStep, setLoadingStep] = useState(false);
  const [showWizardButtonPanel, setShowWizardButtonPanel] =
    useState(null);
  const [customLoadingMessage, setCustomLoadingMessage] =
    useState(null);
  const startStep = 0;
  const payAndPremiumRef = useRef();
  const [enableRenew, setEnableRenew] = useState(true);
  const expandedCard = useRef([
    {
      cardName: 'intermediaryDetails',
      cardFlag: false,
      subSections: [],
    },
    {
      cardName: 'proposerDetails',
      cardFlag: false,
      subSections: [],
    },
    {
      cardName: 'insuredDetails',
      cardFlag: false,
      subSections: [],
    },
    {
      cardName: 'nomineeDetails',
      cardFlag: false,
      subSections: [],
    },
    {
      cardName: 'prevInsuredDetails',
      cardFlag: false,
      subSections: [],
    },
    {
      cardName: 'RenewalMandate',
      cardFlag: false,
      subSections: [],
    },
  ]);

  const renderExpandedCards = useRef([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const renderPayPremiumCards = useRef([
    {cardName: 'cheque 1',flag: true},
    { cardName: 'dd 1', flag: true },
  ]);
  const steps = [
    {
      icon: <FontAwesomeIcon icon={faUsers} />,
      label: 'Review Renewal Proposal',
      proceedLabel: () => 'Renew',
      // disabledLabel: !enableRenew,
      disabledLabel: !enableRenew || rcStatus==='true',
      submitForm: async () => {
        setAlerts([]);
        if (props?.forwardedRenewFormRef?.current) {
          const res =
            await props?.forwardedRenewFormRef?.current?.submitForm();
          return res;
        }
        return false;
      },
      stepNotCompleteAlert: () => {
        let errorCountForInsuredMembers = 0,
          errorCountForNominee = 0,
          errorCountForPreviousInsured = 0;
        if (
          props?.forwardedRenewFormRef?.current?.errors
            ?.insuredDetails
        ) {
          Object.keys(
            props?.forwardedRenewFormRef?.current?.errors
              ?.insuredDetails,
          )?.forEach((insured) => {
            errorCountForInsuredMembers += Object.keys(
              props?.forwardedRenewFormRef?.current?.errors
                ?.insuredDetails[`${insured}`],
            )?.length;
          });
        }
        if (
          props?.forwardedRenewFormRef?.current?.errors
            ?.nomineeDetails
        ) {
          Object.keys(
            props?.forwardedRenewFormRef?.current?.errors
              ?.nomineeDetails,
          )?.forEach((nominee) => {
            errorCountForNominee += Object.keys(
              props?.forwardedRenewFormRef?.current?.errors
                ?.nomineeDetails[`${nominee}`],
            )?.length;
          });
        }
        if (
          props?.forwardedRenewFormRef?.current?.errors
            ?.prevInsuranceDetails
        ) {
          Object.keys(
            props?.forwardedRenewFormRef?.current?.errors
              ?.prevInsuranceDetails,
          )?.forEach((prevInsured) => {
            errorCountForPreviousInsured += Object.keys(
              props?.forwardedRenewFormRef?.current?.errors
                ?.prevInsuranceDetails[`${prevInsured}`],
            )?.length;
          });
        }
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  {!props?.forwardedRenewFormRef?.current?.values
                    ?.intermediaryData?.businessLocation
                    ? `Please select appropriate Business Location before proceeding`
                    : expandedCard?.current?.find(
                        (exp) => exp?.cardName === 'proposerDetails',
                      )?.cardFlag
                    ? `Please save the changes in proposer details before proceeding`
                    : expandedCard?.current?.find(
                        (exp) => exp?.cardName === 'insuredDetails',
                      )?.cardFlag
                    ? `Please save the changes in insured details before proceeding`
                    : expandedCard?.current?.find(
                        (exp) => exp?.cardName === 'nomineeDetails',
                      )?.cardFlag
                    ? `Please save the changes in nominee details before proceeding`
                    : expandedCard?.current?.find(
                        (exp) =>
                          exp?.cardName === 'prevInsuredDetails',
                      )?.cardFlag
                    ? `Please save the changes in previous insurance details before proceeding`
                    : expandedCard?.current?.find(
                        (exp) =>
                          exp?.cardName === 'intermediaryDetails',
                      )?.cardFlag
                    ? `Please save the changes in intermediary details before proceeding`
                    : props?.forwardedRenewFormRef?.current?.errors
                        ?.planName
                    ? `Please select plans and covers before proceeding`
                    : props?.forwardedRenewFormRef?.current?.errors
                        ?.memberLimit
                    ? `${props?.forwardedRenewFormRef?.current?.errors?.memberLimit
                        ?.toString()
                        ?.split('*')[1]
                        ?.trim()}`
                    : props?.forwardedRenewFormRef?.current?.errors
                        ?.proposerDetails &&
                      Object.keys(
                        props?.forwardedRenewFormRef?.current?.errors
                          ?.proposerDetails,
                      )?.length > 0
                    ? `Please review the proposer details section before proceeding`
                    : props?.forwardedRenewFormRef?.current?.errors
                    ?.renewalMandateDetails &&
                  Object.keys(
                    props?.forwardedRenewFormRef?.current?.errors
                      ?.renewalMandateDetails,
                  )?.length > 0
                ? `Renew is not applicable since Renewal Mandate is opted on its previous New Business/RollOver`
                    : props?.forwardedRenewFormRef?.current?.errors?.renewalPaymentMandate ?
                    props?.forwardedRenewFormRef?.current?.errors?.renewalPaymentMandate : 
                    errorCountForInsuredMembers > 0
                    ? `Please review the insured details section before proceeding`
                    : errorCountForNominee > 0
                    ? `Please review the nominee details section before proceeding`
                    : errorCountForPreviousInsured > 0
                    ? `Please review the previous insurance details section before proceeding`
                    : `Please fill the mandatory fields before proceeding`}
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      component: ({ expanded }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading {...{ customMessage: customLoadingMessage }} /> 
            </div>
          ) : (
            <RenewReviewAndConfirm
              setEnableRenew={setEnableRenew}
              forwardedRenewFormRef={props?.forwardedRenewFormRef}
              forwardedPremiumFormRef={props?.forwardedPremiumFormRef}
              expandedCard={expandedCard}
              renderExpandedCards={renderExpandedCards}
              forwardedAlertsRef={props?.forwardedAlertsRef}
              {...{
                setParentAlerts: setAlerts,
                setLoadingStep,
                setCustomLoadingMessage,
                planName,
                planCode,
                productCode,
                renewalMode,
                rcStatus,
                productName,
              }}
            />
          )
        ) : null,
    },
    {
      icon: <FontAwesomeIcon icon={faFileAlt} />,
      label: 'Pay Premium',
      proceedLabel: () => 'Submit',
      submitForm: async () => {
        setAlerts([]);
        if (payAndPremiumRef.current) {
          const res = await payAndPremiumRef.current.submitForm();
          return res;
        }
        return false;
      },
      onPreviousStep: () => {
        if (payAndPremiumRef.current) {
          updateViewRenewPolicy({
            premiumDetails: payAndPremiumRef?.current?.values,
          });
          }
      },
      component: ({ expanded }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : GET_VIEW_RENEW_POLICY_VAR_DETAILS ? (
            <PayPremium
              forwardedRef={payAndPremiumRef}
              {...{
                setLoadingStep,
                setCustomLoadingMessage,
                showSuccessMsg,
                setParentAlerts: setAlerts,
                setShowWizardButtonPanel,
                planName:
                  props?.forwardedPremiumFormRef?.current?.values
                    ?.planName,
                productCode,
                productName,
                planCode,
                renewalMode,
                REACTIVE_VAR_QUERY: GET_VIEW_RENEW_POLICY_VAR_DETAILS,
                reactiveVarName: 'viewRenewPolicy',
                updateReactiveVar: updateViewRenewPolicy,
                modeOfOperation: 'RENEWPOLICY',
                renderExpandedCards: renderPayPremiumCards
              }}
            />
          ) : null
        ) : null,
        
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  {payAndPremiumRef.current.errors?.totalPaymentAmount
                    ? payAndPremiumRef.current.errors
                        ?.totalPaymentAmount
                    : payAndPremiumRef.current.errors?.onlinePayment
                        ?.isTransactionIdVerified
                    ? payAndPremiumRef.current.errors?.onlinePayment
                        ?.isTransactionIdVerified
                    : payAndPremiumRef.current.values
                        ?.termsAndConditions
                    ? `Please fill the mandatory fields before proceeding`
                    : 'Please fill the mandatory fields and accept terms and conditions before proceeding.'}
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
  ]; 
  // console.log(`plancode`,planCode)
  return (
    <Card
      className="min-h-screen"
      severity={`${successMsg ? 'success' : 'info'}`}
    >
      {successMsg ? (
        <SuccessPageHealth
          {...{
            planCode:
              props?.forwardedPremiumFormRef?.current?.values
                ?.planCode,
            planName:
              props?.forwardedPremiumFormRef?.current?.values
                ?.planName,
            REACTIVE_VAR_QUERY: GET_VIEW_RENEW_POLICY_VAR_DETAILS,
            reactiveVarName: 'viewRenewPolicy',
          }}
        />
      ) : (
        <Wizard
          {...{
            steps,
            startStep,
            tabStyle: true,
            switchTabs: true,
            buttonSize: 'medium',
            showButtonPanel:
              showWizardButtonPanel !== null
                ? showWizardButtonPanel
                : !loadingStep,
          }}
        />
      )}
      <NotificationList 
      {...
        { items: alerts, 
          resetAlerts: (idx) => {
            const alertToBeRemovedPos = alerts.findIndex((a) => a.id === idx);
            setAlerts([
              ...alerts.slice(0, alertToBeRemovedPos),
              ...alerts.slice(alertToBeRemovedPos + 1, alerts.length),
            ]);
          }
        }
      } />
    </Card>
  );
}
